exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-popover.tag_popover{padding:0;min-width:20px;background:rgba(15,16,21,.5019607843);border:none;margin-bottom:20px}.el-popover.tag_popover[x-placement^=top] .popper__arrow,.el-popover.tag_popover[x-placement^=top] .popper__arrow:after{border-top-color:rgba(15,16,21,.5019607843)}", ""]);

// exports
